import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.benutzer-zugriff-updated-notification';
import * as api from '../../../clients/api';

@Injectable()
export class ApiBenutzerZugriffUpdatedNotificationEffects {

    BenutzerZugriffUpdatedNotification$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_BENUTZER_ZUGRIFF_UPDATED_NOTIFICATION),
        mergeMap((x: ac.GetBenutzerZugriffUpdatedNotificationAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getBenutzerZugriffUpdatedNotification().pipe(
                map((result: any) => {
                    return new ac.GetBenutzerZugriffUpdatedNotificationErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetBenutzerZugriffUpdatedNotificationFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.CommonTemplatesService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.CommonTemplatesService {
        if (this.service === null) {
            this.service = this.injector.get(api.CommonTemplatesService);
        }
        return this.service;
    }
}
